import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.accessToken;
    const warehouseId = this.authService.getSelectedWarehouseId();
    const skipTokenUrls: string[] = [
      '/auth/login',
      '/auth/forgot-password',
      '/auth/register'
    ];

    const shouldSkip = skipTokenUrls.some(url => req.url.includes(url));

    let authReq = req;

    if (token && !shouldSkip) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {
          this.authService.logout(); 
          this.router.navigate(['/auth/login']);
        } else if(!warehouseId || (error.status === 404 && error.message == 'Warehouse not found')){
        this.router.navigate(['/warehouse/warehouse-list']);
        }

        return throwError(() => error); 
      })
    );
  }
}